import React, { useEffect, useState } from "react";

export default function AddToHomeScreenButton() {
  const [installPrompt, setInstallPrompt] = useState(null);
  const [showIosInstructions, setShowIosInstructions] = useState(false);
  const [isIos, setIsIos] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    const ios =
      /iPhone|iPad|iPod/i.test(navigator.userAgent) ||
      (navigator.platform === "MacIntel" &&
        navigator.maxTouchPoints > 1);

    setIsIos(ios);

    const standalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true;

    setIsInstalled(standalone);

    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setInstallPrompt(event);
    };

    const handleAppInstalled = () => {
      setIsInstalled(true);
      setInstallPrompt(null);

      window.gtag?.("event", "pwa_installed");
    };

    window.addEventListener(
      "beforeinstallprompt",
      handleBeforeInstallPrompt
    );

    window.addEventListener("appinstalled", handleAppInstalled);

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt
      );

      window.removeEventListener(
        "appinstalled",
        handleAppInstalled
      );
    };
  }, []);

  const handleInstall = async () => {
    // Already installed
    if (isInstalled) {
      return;
    }

    // iPhone / iPad
    if (isIos) {
      setShowIosInstructions(true);

      window.gtag?.("event", "install_instructions_viewed", {
        platform: "ios",
      });

      return;
    }

    // Android / Chrome
    if (installPrompt) {
      installPrompt.prompt();

      const { outcome } = await installPrompt.userChoice;

      window.gtag?.("event", "add_to_home_screen", {
        platform: "android",
        outcome,
      });

      setInstallPrompt(null);

      return;
    }
  };

  if (isInstalled) {
    return null;
  }

  return (
    <>
      <button style={{
        margin:"1em auto", 
        padding:"1rem", 
        backgroundColor:"yellow",
        fontSize:"1rem",
        borderRadius:"1rem",
        fontWeight:"900",
        marginRight:"1rem",
        border:"1px solid gold"

    }}
      type="button" onClick={handleInstall}>
        🏠 Add to Home Screen
      </button>

      {showIosInstructions && (
        <div className="ios-install-modal">
          <div className="ios-install-content">
            <button
              type="button"
              onClick={() => setShowIosInstructions(false)}
              aria-label="Close"
            >
              ×
            </button>

            <h3>Add the crossword to your iPhone</h3>

            <ol>
              <li>
                Tap the <strong>Share</strong> button in Safari.
              </li>
              <li>
                Select <strong>Add to Home Screen</strong>.
              </li>
              <li>
                Tap <strong>Add</strong>.
              </li>
            </ol>

            <button
              type="button"
              onClick={() => setShowIosInstructions(false)}
            >
              Got it
            </button>
          </div>
        </div>
      )}
    </>
  );
}